import get from 'lodash/get';

import {
  createReqConsts,
  createActions,
  createReqWatcher,
  initialState as rootState,
} from '../../../utils/redux';
import createReqReducer from '../../../utils/redux/req-reducer';

const requestOptions = {
  endpoint: 'appointments',
  type: 'get',
  slug: [
    'repeatable_appointments',
    {
      type: 'payload.query',
      queryParameter: 'user_id',
      selector: 'userId',
    },
    {
      type: 'payload.query',
      queryParameter: 'organization_id',
      selector: 'organizationId',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

export const consts = createReqConsts('appointment-form', 'my-providers-req', [
  'LOAD_MORE',
  'SELECT_MY_PROVIDER',
  'INIT',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export const paginationConsts = createReqConsts(
  'appointment-form',
  'my-providers-req-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
);

const defaultRequestReducer = createReqReducer(consts);

const initialState = {
  ...rootState,
  count: 0,
  data: { appointments: [], visitTypes: [] },
  paginationSending: false,
  pagination: { offset: 0, limit: 10 },
};

export default function(state = initialState, action) {
  switch (action.type) {
    case consts.SEND: {
      return {
        ...state,
        succeed: null,
        rejected: null,
        error: null,
        count: action.payload.count || 0,
        sending: !action.payload.silent,
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        succeed: true,
        sending: false,
        data: action.payload,
      };
    }

    case paginationConsts.SEND: {
      return {
        ...state,
        paginationSending: true,
      };
    }

    case paginationConsts.SUCCEED: {
      return {
        ...state,
        paginationSending: false,
        data: {
          ...state.data,
          appointments: [
            ...state.data.appointments,
            ...action.payload.appointments,
          ],
        },
      };
    }

    case paginationConsts.REJECTED:
    case paginationConsts.ERROR_ENCOUNTERED: {
      return {
        ...state,
        paginationSending: false,
      };
    }

    case paginationConsts.ADD_META:
    case consts.ADD_META: {
      return {
        ...state,
        count: get(action.payload, 'total', 0),
      };
    }

    case consts.CLEAR: {
      return initialState;
    }

    default:
      return defaultRequestReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/my-providers-req.js